import { tooltipContentStyles } from '@/components/common/tooltip'
import { cn } from '@/utils/cn'
import type { HTMLAttributes } from 'react'

export const ChartTooltip = ({ className, children, ...props }: HTMLAttributes<HTMLDivElement>) => {
  return (
    <div className={cn(tooltipContentStyles, className)} {...props}>
      {children}
    </div>
  )
}
